import React, { createContext, useContext, useEffect, useState } from 'react';
import { auth, db } from '../utils/firebaseConfig';
import { doc, getDoc } from 'firebase/firestore';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      try {
        setCurrentUser(user);
        if (user) {
          const userRef = doc(db, 'users', user.uid);
          const userSnap = await getDoc(userRef);
          if (userSnap.exists()) {
            setUserData(userSnap.data());
          } else {
            console.warn('No se encontraron datos de usuario en Firestore para:', user.uid);
            // Crear documento básico si no existe
            setUserData({
              uid: user.uid,
              email: user.email,
              name: user.displayName || '',
              role: 'cliente',
            });
          }
        } else {
          setUserData(null);
        }
      } catch (error) {
        console.error('Error al obtener datos del usuario:', error);
        setUserData(null);
      } finally {
        setLoading(false);
      }
    });

    return unsubscribe;
  }, []);

  const logout = async (clearCart) => {
    try {
      await auth.signOut();
      setCurrentUser(null);
      setUserData(null);
      if (clearCart) clearCart();
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    }
  };

  return (
    <AuthContext.Provider value={{ currentUser, userData, logout, loading }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

